import SweetAlert from 'react-bootstrap-sweetalert';

const DeleteModal = ({
  close,
  text,
  title,
  confirm,
  confirmText = 'Delete',
  cancelText = 'Cancel',
  isLoading = false,
  manualConfirm = false,
}) => {
  const handleConfirm = () => {
    if (!isLoading) {
      (confirm || close)();
    }
  };

  const handleCancel = () => {
    if (!isLoading) {
      close();
    }
  };

  return (
    <SweetAlert
      title={title}
      warning
      allowEscape={!isLoading}
      closeOnClickOutside={!isLoading}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
      showCancel={!manualConfirm}
      confirmBtnText={isLoading ? 'Deleting...' : confirmText}
      confirmBtnBsStyle="success"
      cancelBtnBsStyle="danger"
      disabled={isLoading}
      customButtons={
        manualConfirm ? (
          <div className="d-flex justify-content-center gap-2">
            <button
              type="button"
              className="btn btn-danger btn-lg"
              onClick={handleCancel}
              disabled={isLoading}
            >
              {cancelText}
            </button>
            <button
              type="button"
              className="btn btn-success btn-lg"
              onClick={handleConfirm}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <i className="bx bx-loader bx-spin me-1" />
                  Deleting...
                </>
              ) : (
                confirmText
              )}
            </button>
          </div>
        ) : null
      }
    >
      {text}
    </SweetAlert>
  );
};

export default DeleteModal;
